import React, { createContext, Component } from "react";
import Subscriptions from "../Components/NewFuncComponents/Subscriptions";

export const GlobalContext = createContext();

export class GlobalContextProvider extends Component {
  constructor() {
    super();
    this.state = {
      thumbnailSize: window.localStorage.getItem("thumbnail-size") || "medium",
      viewerId: null,
      viewerObj: null,
      connectedStripeId: null,
      ownerOfVODId: null,
      companyEndpoint: null,
      subscriptions: [],
      subscriptionSubModel: "",
      config: { hideViews: false },
      darkMode:JSON.parse(window.localStorage.getItem("darkMode")) || false,
      toggleDarkMode: (val) => {
        window.localStorage.setItem("darkMode",val.toString());this.setState({darkMode:val})
        
      },
      setHideViews: (hideViews) => {
        this.setState({ config: { hideViews } });
      },
      setCompanyEndpoint: (companyEndpoint) => {
        this.setState({ companyEndpoint });
      },
      setSubscriptionSubModel: (subscriptionSubModel) => {
        this.setState({ subscriptionSubModel });
      },
      setConnectedStripeId: (connectedStripeId) =>
        this.setState({ connectedStripeId }),
      setOwnerOfVODId: (user) => {
        //check if _ids match to verify client is on the same vod
        if (this.ownerOfVODId === user) return;
        this.setState({ ownerOfVODId: user });
      },
      setViewerObj: (viewerObj) => {
        this.setState({ viewerObj });
      },
      setViewerId: (viewerId) => {
        this.setState({ viewerId });
      },
      setSubscriptions: (subscriptions) => {
        this.setState({ subscriptions });
      },
      setThumbnailSize: (thumbnailSize) => {
        this.setState({ thumbnailSize });
        window.localStorage.setItem("thumbnail-size", thumbnailSize);
      },
    };
  }
  componentDidUpdate() {
    if(this.state.darkMode){
      window.document.getElementsByTagName('body')[0].classList.add('dark')
    } else {
      window.document.getElementsByTagName('body')[0].classList.remove('dark')
    }
  }
  render() {
    
    return (
      <GlobalContext.Provider value={this.state}>
        {this.props.children}
      </GlobalContext.Provider>
    );
  }
}
